var styles = {"box":"Options_box_wt3aq_1","switch":"Options_switch_wt3aq_4","options":"Options_options_wt3aq_7","options-wrapper":"Options_options-wrapper_wt3aq_13","group-name":"Options_group-name_wt3aq_16","no-results":"Options_no-results_wt3aq_29","light":"Options_light_wt3aq_39","scrollbar":"Options_scrollbar_wt3aq_43"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
